module.exports = __webpack_public_path__ + "img/12.beab4f48.png";